import type { PrivacySettings, ScreenshotSettings, WidgetSettings } from './types.ts';

export const DEFAULT_WIDGET: WidgetSettings = {
  position: 'bottom-right',
  offsetX: 20,
  offsetY: 20,
  launcher: 'bubble',
  autoAvoid: true,
  zIndex: 2147483000,
  hidden: false,
  excludePaths: [],
};

export const DEFAULT_SCREENSHOT: ScreenshotSettings = { enabled: true, defaultOn: true };

export const DEFAULT_PRIVACY: PrivacySettings = {
  redactSelectors: ['input[type="password"]', '[data-gsb-redact]', '[autocomplete^="cc-"]'],
  redactQueryParams: ['token', 'access_token', 'id_token', 'code', 'state', 'session', 'sid', 'password', 'passwort', 'key', 'apikey', 'api_key', 'secret', 'signature', 'auth'],
};
